import type { Questionnaire, Task } from '@medplum/fhirtypes'

export const createSDRActionQuestionnaire = {
  resourceType: 'Questionnaire',
  url: 'https://www.seenhealth.org/fhir/Questionnaire/create-sdr-action',
  id: 'sdr-create-sdr-action',
  status: 'draft',
  subjectType: ['Task'],
  name: 'Create SDR Action',
  title: '',
  item: [
    // TODO: implement reference support in custom questionnaire, we can work around this for now
    // {
    //   linkId: 'practitioner',
    //   text: 'Practitioner',
    //   type: 'reference',
    //   required: true,
    //   extension: [
    //     {
    //       url: 'http://hl7.org/fhir/StructureDefinition/questionnaire-referenceResource',
    //       valueCodeableConcept: {
    //         coding: [
    //           {
    //             code: 'Practitioner',
    //           },
    //         ],
    //       },
    //     },
    //   ],
    // },
    {
      linkId: 'description',
      text: 'Description',
      type: 'string',
      required: true,
    },
    {
      linkId: 'dueDate',
      text: 'Due Date',
      type: 'date',
      required: true,
    },
    {
      linkId: 'priority',
      text: 'Priority',
      type: 'choice',
      required: true,
      answerOption: [
        { valueString: 'routine' },
        { valueString: 'urgent' },
        { valueString: 'asap' },
        { valueString: 'stat' },
      ] satisfies { valueString: Task['priority'] }[],
    },
  ] as const,
} satisfies Questionnaire
